var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotStar = function SvgTrustpilotStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.1042L10.0417 9.33333L11.3125 13.25L7 10.1042ZM14 5.04167H8.64583L7 0L5.35417 5.04167H0L4.33334 8.16667L2.6875 13.2083L7.02083 10.0833L9.6875 8.16667L14 5.04167Z",
    fill: "#219653"
  })));
};
export default SvgTrustpilotStar;